<button (click)="openCreate()" class="btn btn-primary-outline add-button">Add</button>
<h4>Specific Store Trading Times</h4>
<table class="table">
  @for (workingTime of workingTimes(); track workingTime) {
    <tr>
      <td>{{ workingTime.startDate }}</td>
      <td>
        {{ workingTime.workingTime.openingTime | timeParse | dateFormat: 'HH:mm' }} -
        {{ workingTime.workingTime.closingTime | timeParse | dateFormat: 'HH:mm' }}
      </td>
      <td>
        @if (canEditAtDate(workingTime.startDate)) {
          <i
                  (click)="openUpdate(workingTime)"
                  class="fa fa-xs fa-pen pointer me-1">
          </i>
        }
        @if (canEditAtDate(workingTime.startDate)) {
          <i
                  (click)="openDelete(workingTime.startDate)"
                  class="fa fa-xs fa-trash pointer">
          </i>
        }
      </td>
    </tr>
  }
</table>